import * as React from 'react';
import { connect as FormikConnect } from 'formik';
import { DropdownField } from '@ane/ui-components/lib/components/FormikFormFields/DropdownField';
import { ButtonDialogType, FormActions, Dialog, PrimaryButton, DefaultButton } from '@ane/ui-components';
import { SpecialColumnsComponentConstants } from '../../../../constants/DataSource.constants';
import { useState } from 'react';
import { useSelector } from 'react-redux';
export function SpecialColumnsDropdown(props) {
    var _a, _b, _c;
    const { formik, index, dropdownProps = {}, fieldName } = props;
    const flightFormats = useSelector((state) => state.dataSourceManagementModule.dataSourceFlightFormats.items.data);
    const { setFieldValue, values } = formik;
    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const currentValue = (_c = (_b = (_a = values.flightList) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.Example) !== null && _c !== void 0 ? _c : '';
    const [originalValue, setOriginalValue] = useState([]);
    const [newValue, setNewValue] = useState([]);
    const _onChange = (ev, option) => {
        if (!(option === null || option === void 0 ? void 0 : option.data)) {
            return;
        }
        const newList = [...values.flightList];
        newList[index] = {
            ...newList[index],
            Format: option.data.Example,
            Example: option.data.Example,
            Source: option.data.Source,
            Definition: option.data.Definition,
        };
        if (!(flightFormats === null || flightFormats === void 0 ? void 0 : flightFormats.map((item) => item.Example).includes(currentValue)) && currentValue !== '') {
            setShowConfirmDialog(true);
            setOriginalValue(values.flightList);
            setNewValue(newList);
        }
        else {
            setFieldValue === null || setFieldValue === void 0 ? void 0 : setFieldValue(`flightList`, newList);
        }
    };
    const _onDismissDialog = () => {
        setShowConfirmDialog(false);
        setFieldValue === null || setFieldValue === void 0 ? void 0 : setFieldValue('flightList', originalValue);
    };
    const _onConfirmDialog = () => {
        setShowConfirmDialog(false);
        setFieldValue === null || setFieldValue === void 0 ? void 0 : setFieldValue('flightList', newValue);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DropdownField, { ...dropdownProps, name: fieldName, ariaLabel: `Select flight format-${props.index}`, options: props.formatOptions, description: 'Select format', onChange: _onChange }),
        React.createElement(Dialog, { hidden: !showConfirmDialog, dialogContentProps: {
                title: SpecialColumnsComponentConstants.FlightDoubleConfirmDialog.title,
                type: ButtonDialogType.normal,
            }, maxWidth: 600, minWidth: 500, modalProps: {
                isBlocking: false,
            }, onRenderFooter: () => (React.createElement(FormActions, null,
                React.createElement(PrimaryButton, { ariaLabel: SpecialColumnsComponentConstants.FlightDoubleConfirmDialog.confirmBtn.ariaLabel, onClick: _onConfirmDialog, text: SpecialColumnsComponentConstants.FlightDoubleConfirmDialog.confirmBtn.label }),
                React.createElement(DefaultButton, { ariaLabel: SpecialColumnsComponentConstants.FlightDoubleConfirmDialog.cancelBtn.ariaLabel, onClick: _onDismissDialog, text: SpecialColumnsComponentConstants.FlightDoubleConfirmDialog.cancelBtn.ariaLabel }))) },
            SpecialColumnsComponentConstants.FlightDoubleConfirmDialog.subText,
            React.createElement("br", null),
            "(You will not be able to revert back to ",
            React.createElement("b", null, currentValue),
            ". Click cancel to keep the format unchanged.")));
}
export default FormikConnect(SpecialColumnsDropdown);

//# sourceMappingURL=SpecialColumnsDropdown.js.map
